import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion } from 'framer-motion';
const FEATURED_LIFESTYLE_IMAGE = 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?q=80&w=1600&auto=format&fit=crop';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const easeOutCubic = [0.33, 1, 0.68, 1];
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="testimonios" className="py-20 lg:py-28 bg-brand-cream" data-id="element-274" data-mp="42t35cdv0tp1">
      <div className="container mx-auto px-6" data-id="element-275" data-mp="40zwhx38y9h1">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-276" data-mp="91e63jkhxrh6">
          <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-277" data-mp="9030de7hq9nf">
            {t('testimonials.eyebrow')}
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-brand-dark mb-6 tracking-tight" data-id="element-278" data-mp="2aukdrctyhzfy">
            {t('testimonials.heading')}
          </h2>
          <p className="text-brand-dark/60 font-light text-lg" data-id="element-279" data-mp="1sl2ijiw5x5u8">
            {t('testimonials.subheading')}
          </p>
          <div className="w-12 h-px bg-brand-gold mx-auto mt-10" data-id="element-280" data-mp="1nt117ik50oxc"></div>
        </div>

        {/* FEATURED EDITORIAL BANNER — aspirational lifestyle */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.1,
        ease: easeOutCubic
      }} className="relative rounded-[2rem] overflow-hidden max-w-6xl mx-auto" data-id="element-281" data-mp="1et4l45btcydw">
          <div className="relative aspect-[16/9] md:aspect-[21/9]" data-id="element-282" data-mp="1xiufwsfktk5t">
            <img src={FEATURED_LIFESTYLE_IMAGE} alt="Lipo Laser Beverly Hills — real patient silhouette" className="absolute inset-0 w-full h-full object-cover" data-id="element-283" data-mp="r439683rv53v" />
            {/* Soft warm gradient from left → so text reads cleanly */}
            <div className="absolute inset-0 bg-gradient-to-r from-brand-cream/95 via-brand-cream/60 to-transparent" data-id="element-284" data-mp="skh2r53n8k9z"></div>
            <div className="absolute inset-0 bg-grain opacity-30 pointer-events-none mix-blend-multiply" data-id="element-285" data-mp="ejwgu02fm8c9"></div>
          </div>

          {/* Overlay editorial copy */}
          <div className="absolute inset-0 flex items-center" data-id="element-286" data-mp="4vel3x90erfh">
            <div className="px-8 md:px-16 max-w-md" data-id="element-287" data-mp="4ttps5evf4gk">
              <div className="inline-flex items-center gap-3 mb-5" data-id="element-288" data-mp="9m4o53tyqi70">
                <span className="w-8 h-px bg-brand-gold" data-id="element-289" data-mp="3r2ctut4dpswu"></span>
                <span className="text-brand-dark/60 font-medium tracking-[0.25em] text-[10px] uppercase" data-id="element-290" data-mp="3r3xp6kyipfvr">
                  {t('testimonials.bannerTag')}
                </span>
              </div>
              <p className="font-serif italic text-2xl md:text-3xl lg:text-4xl text-brand-dark font-light leading-tight mb-6" data-id="element-291" data-mp="3i26hxbobx0zs">
                "{t('testimonials.bannerQuote')}"
              </p>
              <p className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50" data-id="element-292" data-mp="33fhlxjtad5y5">
                {t('testimonials.bannerAttribution')}
              </p>
            </div>
          </div>
        </motion.div>

        {/* Privacy note + CTA */}
        <div className="text-center mt-20 max-w-2xl mx-auto" data-id="element-293" data-mp="38dj482iw118k">
          <p className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/30 mb-10" data-id="element-294" data-mp="38g5ck4dlrkru">
            {t('testimonials.privacyNote')}
          </p>
          <button onClick={scrollToContact} className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-dark border-b border-brand-gold/60 hover:border-brand-gold pb-2 transition-colors" data-id="element-295" data-mp="3hdpfdhr45p4k">
            {t('nav.cta')} →
          </button>
        </div>
      </div>
    </section>;
}